const POINT_MARKER_ICON_CONFIG = {
  path: "M 0, 0 m -5, 0 a 5,5 0 1,0 10,0 a 5,5 0 1,0 -10,0",
  strokeOpacity: 1,
  strokeWeight: 2,
  strokeColor: "#fff",
  fillColor: "#e8425c",
  fillOpacity: 1,
  scale: 1,
};

const LINE_PATH_CONFIG = {
  strokeColor: "#ff0000",
  strokeOpacity: 0.3,
  strokeWeight: 2,
  fillColor: "#e8425c",
  fillOpacity: 0.5,
  clickable: false,
};

const mapSettings = {
  clickableIcons: false,
  streetViewControl: false,
  panControlOptions: false,
  gestureHandling: "cooperative",
  mapTypeControl: false,
  zoom: 9,
  styles: [
    {
      featureType: "poi.place_of_worship",
      elementType: "all",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "road.arterial",
      elementType: "geometry",
      stylers: [{ color: "#ffffff" }, { weight: 1.97 }],
    },
    { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#ffffff" }] },
    {
      featureType: "road.arterial",
      elementType: "labels",
      stylers: [{ visibility: "on" }, { color: "#b5a7b5" }],
    },
    {
      featureType: "road.arterial",
      elementType: "labels.icon",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "road.arterial",
      elementType: "labels.text.stroke",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "road.highway",
      elementType: "labels.text",
      stylers: [{ visibility: "on" }, { color: "#ffffff" }],
    },
    {
      featureType: "road.highway",
      elementType: "labels.text.stroke",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "road.highway",
      elementType: "labels.icon",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "administrative.locality",
      elementType: "labels.text",
      stylers: [{ visibility: "on" }, { color: "#080a1f" }],
    },
    {
      featureType: "administrative.locality",
      elementType: "labels.text.stroke",
      stylers: [{ visibility: "on" }, { color: "#ffffff" }, { weight: 5.52 }],
    },
    { featureType: "road", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
    {
      featureType: "poi",
      elementType: "labels.text.stroke",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "road.local",
      elementType: "labels.text.fill",
      stylers: [{ visibility: "on" }, { lightness: 37 }],
    },
    {
      featureType: "road.local",
      elementType: "labels.text.stroke",
      stylers: [{ visibility: "off" }, { weight: 6.26 }],
    },
    {
      featureType: "administrative.country",
      elementType: "all",
      stylers: [{ visibility: "off" }, { color: "#ffffff" }],
    },
    { featureType: "water", elementType: "geometry.fill", stylers: [{ color: "#cbccd6" }] },
    {
      featureType: "administrative.country",
      elementType: "geometry.stroke",
      stylers: [{ visibility: "on" }, { color: "#8a8a8a" }, { weight: 0.86 }],
    },
    {
      featureType: "administrative.province",
      elementType: "geometry.stroke",
      stylers: [{ visibility: "on" }, { color: "#ffffff" }, { weight: 0.79 }],
    },
    { featureType: "road", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
    { featureType: "road", elementType: "labels.text.fill", stylers: [{ color: "#8a8a8a" }] },
    {
      featureType: "landscape",
      elementType: "geometry.fill",
      stylers: [{ color: "#f6f6f6" }],
    },
    { featureType: "transit", elementType: "labels", stylers: [{ visibility: "off" }] },
    { featureType: "poi", elementType: "geometry.fill", stylers: [{ color: "#f6f6f6" }] },
    {
      featureType: "poi",
      elementType: "labels.icon",
      stylers: [{ saturation: -100 }, { lightness: 8 }],
    },
    {
      featureType: "landscape.man_made",
      elementType: "geometry.stroke",
      stylers: [{ visibility: "off" }],
    },
    { featureType: "water", elementType: "labels", stylers: [{ color: "#636363" }] },
    { featureType: "poi", elementType: "labels.text", stylers: [{ saturation: -100 }] },
    { featureType: "poi", elementType: "geometry.stroke", stylers: [{ visibility: "off" }] },
    { featureType: "poi.school", elementType: "labels", stylers: [{ visibility: "off" }] },
    { featureType: "poi.business", elementType: "labels", stylers: [{ visibility: "off" }] },
    {
      featureType: "poi.government",
      elementType: "labels",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "poi.attraction",
      elementType: "labels",
      stylers: [{ visibility: "off" }],
    },
  ],
};

export { mapSettings, LINE_PATH_CONFIG, POINT_MARKER_ICON_CONFIG };
